import { createEvoClient, phoneValidation } from "@jti/evo-client";
import { getConfig } from "@jti/fe-common";
import type { PhoneVerificationResponseType, PhoneVerificationType, PlatformApiContract } from "@jti/rest-api-types";

import { getUser } from "../../utils";

export class PlatformApi implements PlatformApiContract {
  private readonly client;

  constructor(baseUrl: string, tenantToken: string, recaptchaId: string) {
    const { ciam_token } = getUser();
    this.client = createEvoClient({
      baseUrl,
      tenantToken,
      recaptchaId,
      ciamToken: ciam_token,
      throwOnError: true,
    });
  }

  static init(): PlatformApi {
    const { EVO_DOMAIN, EVO_TENANT, "X-RECAPTCHA-ID": recaptchaId } = getConfig();
    return new PlatformApi(EVO_DOMAIN, EVO_TENANT, recaptchaId);
  }

  async verifyPhone(phone: string, validationType?: PhoneVerificationType): Promise<PhoneVerificationResponseType> {
    const { data } = await phoneValidation({
      client: this.client,
      body: { phone, ...(validationType && { type: validationType }) },
    });

    return {
      is_valid: Boolean(data?.data?.is_valid),
      phone: data?.data?.phone ?? "",
      message: data?.data?.message ?? "",
    };
  }
}
